import type { I18n } from "@lingui/core"
import { msg } from "@lingui/core/macro"
import { formatTime } from "../../../../../lib/format-date"
import { languageDisplayName } from "../../../../../lib/language-display"
import { languageTimeline } from "../../../-transcript/helpers"

export interface ILiteMeta {
  dateLabel: string
  timeRange: string | null
  durationLabel: string
  languageParts: string[]
}

export function buildLiteMeta(
  i18n: I18n,
  args: {
    startTime: string | null
    durationMinutes: number
    sourceLocale?: string | null
    segments?: readonly { start: number; language?: string }[]
  },
): ILiteMeta {
  const start = args.startTime ? new Date(args.startTime) : null
  const startValid = start !== null && !Number.isNaN(start.getTime())
  const dateLabel = startValid
    ? i18n.date(start, { weekday: "short", day: "numeric", month: "short", year: "numeric" })
    : ""

  let timeRange: string | null = null
  if (startValid) {
    const startLabel = formatTime(i18n, start)
    if (args.durationMinutes > 0) {
      const end = new Date(start.getTime() + args.durationMinutes * 60 * 1000)
      timeRange = `${startLabel} – ${formatTime(i18n, end)}`
    } else {
      timeRange = startLabel
    }
  }

  const durationLabel = i18n._(msg`${args.durationMinutes} min`)

  const { primary, switchTo } = languageTimeline(args.segments, args.sourceLocale)
  const languageParts: string[] = []
  if (primary) languageParts.push(languageDisplayName(primary, i18n.locale))
  if (switchTo && startValid) {
    const at = new Date(start.getTime() + switchTo.atSeconds * 1000)
    const name = languageDisplayName(switchTo.code, i18n.locale)
    const when = formatTime(i18n, at)
    languageParts.push(i18n._(msg`${name} from ${when}`))
  }

  return { dateLabel, timeRange, durationLabel, languageParts }
}
